import * as XLSX from "xlsx";
import { formatDate } from "../common/Converter";
import { resolveSalaryGradesForExport } from "./exportSalaryGradeUtils";

/** Keep calendar date only (e.g. 2018-12-27T00:00:00.000Z → 2018-12-27). */
function toDateOnly(value) {
  if (value == null || value === "") return "";
  if (typeof value === "string") {
    const match = value.match(/^(\d{4}-\d{2}-\d{2})/);
    if (match) return match[1];
  }
  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) return String(value);
  return date.toISOString().split("T")[0];
}

function formatExportDate(dateStr) {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr ?? "";
 
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
 }
 
 function isDateField(config) {
  const type = (config?.type || "").toLowerCase();
  return type === "date" || type === "datetime" || type === "datetime-local";
 }
 

export default async function ExportCSVFunction(objects, exportName, schema, fields) {
  if (!objects || !Array.isArray(objects)) {
    this.view.showError("No data found for export.");
    return;
  }

  const camelToLabel = (str) =>
    str.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase());

  const label = fields
    .filter((fieldName) => {
      const config = schema.fields[fieldName];
      return config && config.read !== false;
    })
    .map((fieldName) => ({
      key: fieldName,
      label: schema.fields[fieldName].label || camelToLabel(fieldName),
      type: schema.fields[fieldName].type,
      config: schema.fields[fieldName],
    }));

    // let totalExpences = "";

      //   if (schema.collection === "recipient_log") {
  //     label.push({ key: "totalExpences", label: "Total Expenses" });
  //     totalExpences = this.formatIntoPeso(
  //       objects.reduce(
  //         (sum, item) =>
  //           sum +
  //           parseFloat((item.amount || "0").toString().replace(/[^0-9.-]+/g, "")),
  //         0
  //       )
  //     );
  //   }

  if (fields.includes("salaryGrade")) {
    await resolveSalaryGradesForExport(objects);
  }

  const processedData = objects.map((obj) => {
    const rowObj = { ...obj };

    const positionTitle =
      typeof rowObj.position === "object"
        ? rowObj.position?.position_title || ""
        : rowObj.position || "";
    const nonRegPositionTitle =
      typeof rowObj.nonRegPosition === "object"
        ? rowObj.nonRegPosition?.positionTitle || ""
        : rowObj.nonRegPosition || "";

    rowObj.position = positionTitle || nonRegPositionTitle;
    if (rowObj.nonRegPosition) {
      rowObj.nonRegPosition = nonRegPositionTitle;
    }
    if (rowObj.employmentType) {
      rowObj.employmentType =
        typeof rowObj.employmentType === "object"
          ? rowObj.employmentType.name || ""
          : rowObj.employmentType;
    }
    if (rowObj.employee) {
      rowObj.employee = `${rowObj.employee.Firstname || ""} ${
        rowObj.employee.Middlename || ""
      } ${rowObj.employee.surname || ""}`.trim();
    }
    if (rowObj.supervisor) {
      rowObj.supervisor = `${rowObj.supervisor.Firstname || ""} ${
        rowObj.supervisor.Middlename || ""
      } ${rowObj.supervisor.surname || ""}`.trim();
    }
    if (rowObj.updatedAt) {
      rowObj.updatedAt = formatDate(rowObj.updatedAt);
    }

    const processedRow = {};
    label.forEach(({ key, label: headerLabel, type, config }) => {
      let val = rowObj[key];
      const looksLikeIsoDate =
        typeof val === "string" && /^\d{4}-\d{2}-\d{2}T/.test(val);
      if (type === "Date" || looksLikeIsoDate) {
        val = toDateOnly(val);
      }

      if (val != null && isDateField(config)) {
        val = formatExportDate(val);
      }
      const next = val == null ? "" : String(val);
      // Duplicate schema labels (e.g. position + positionLabel both "Position")
      // must not overwrite a resolved value with an empty one.
      if (next === "" && processedRow[headerLabel]) return;
      processedRow[headerLabel] = next;
    });

    return processedRow;
  });

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(processedData);

  const colWidths = label.map(({ label: header }) => {
    const maxWidth = Math.max(
      header.length,
      ...processedData.map((row) => (row[header] || "").length),
    );
    return { wch: Math.min(Math.max(maxWidth + 2, 10), 50) };
  });
  worksheet["!cols"] = colWidths;

  const range = XLSX.utils.decode_range(worksheet["!ref"]);

  for (let col = range.s.c; col <= range.e.c; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
    if (worksheet[cellAddress]) {
      worksheet[cellAddress].s = {
        font: {
          bold: true,
        },
        alignment: {
          vertical: "center",
          horizontal: "center",
        },
      };
    }
  }

  XLSX.utils.book_append_sheet(workbook, worksheet, "Export Data");
  XLSX.writeFile(workbook, `${exportName}.xlsx`, { cellStyles: true });
}
